import { memo, useContext, useMemo } from 'react';
import { ChatMessagesContainer } from './components/chat-messages-container';
import { useAppDispatch, useAppSelector } from '../../../common/store';
import { chatSelector } from '../../../common/store/chat/selectors';
import { BotChatStreamingMessage } from './components/bot-chat-streaming-message';
import { ChatContext } from '../../contexts/chat-context';
import { SuggestionChips } from './components/suggestion-chips';
import { InMessageInput } from './components/message-input';
import { onDoneAnimationBuffer } from '../../../common/store/chat/chat-slice';
import { appStateSelector } from '../../../common/store/app-state/selectors';
import { FeedbackForm } from './components/feedback-form';
import MessageParser from './components/message-parser';

const ChatMessages = () => {
  const storeMessages = useAppSelector(chatSelector);
  const app = useAppSelector(appStateSelector);
  const dispatch = useAppDispatch();
  const { messagesContainerRef, offsetRef,isAgentTyping } = useContext(ChatContext);

  const onDoneAnimation = () => {
    dispatch(onDoneAnimationBuffer({ conversationId: app.conversationId }));
  }

  const isWaitingAnimationOrResponse = useMemo(
    () => storeMessages.isStreamingHandling || !storeMessages.isDoneAnimationBuffer || isAgentTyping,
    [storeMessages.isStreamingHandling, storeMessages.isDoneAnimationBuffer,isAgentTyping],
  );

  const shouldShowControls = useMemo(
    () => storeMessages.messages.length > 0 && !isWaitingAnimationOrResponse,
    [isWaitingAnimationOrResponse, storeMessages.messages],
  )

  return (
    <ChatMessagesContainer className="voa_chat_body" ref={messagesContainerRef}>
      {storeMessages.messages.map((message, index) => (
        <MessageParser key={message.turn_id} message={message} index={index} />
      ))}
      {isWaitingAnimationOrResponse &&
        <BotChatStreamingMessage
          onDoneAnimation={onDoneAnimation}
          buffer={storeMessages.buffer}
          agentTyping={isAgentTyping}
        />
      }
      {shouldShowControls && (
        <div id="chat-controls">
          <InMessageInput />
          <SuggestionChips />
          <FeedbackForm />
        </div>
      )}
      <div ref={offsetRef} />
    </ChatMessagesContainer>
  )
};

export default ChatMessages;
